module.exports = __webpack_public_path__ + "img/dialog-bg1.a3db880d.png";